"use client";

import { ChevronRight } from "lucide-react";

interface SearchStyleBreadcrumbsProps {
  className?: string;
  onSegmentClick?: (path: string[]) => void;
  debugWhenEmpty?: boolean;
  partsOverride?: string[];
}

export default function SearchStyleBreadcrumbs({
  className = "",
  onSegmentClick,
  debugWhenEmpty = false,
  partsOverride,
}: SearchStyleBreadcrumbsProps) {
  const parts = partsOverride?.filter(Boolean) ?? [];

  if (!parts || parts.length === 0) {
    if (debugWhenEmpty) {
      return (
        <div className={`text-xs text-muted-foreground ${className}`}>
          <div className="inline-flex items-center gap-2 rounded border border-amber-200 bg-amber-50 px-3 py-1.5 text-amber-700">
            <span>Category breadcrumbs unavailable.</span>
            <span className="opacity-80">No browse menu path provided.</span>
          </div>
        </div>
      );
    }
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className={`flex items-center ${className}`}>
      <ol className="flex items-center gap-2 text-xs text-muted-foreground md:text-sm">
        {parts.map((segment, index) => {
          const isFirst = index === 0;
          const isLast = index === parts.length - 1;
          const pathUpToHere = parts.slice(0, index + 1);
          return (
            <li key={`${segment}-${index}`} className="flex items-center">
              {!isFirst && <ChevronRight className="h-3 w-3" />}
              {isLast ? (
                <span className={isFirst ? "ml-0 text-foreground" : "ml-1 text-foreground"}>
                  {segment}
                </span>
              ) : (
                <button
                  type="button"
                  className={isFirst ? "ml-0 hover:underline" : "ml-1 hover:underline"}
                  onClick={() => onSegmentClick?.(pathUpToHere)}
                >
                  {segment}
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
